// NOTE: hooks
import { toast } from "sonner";
import useStaffInvitation from "./useStaffInvitation";
import useFirebaseFile from "../../hooks/useFirebaseFile";
// NOTE: components
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import Loading from "../ui/Loading";
import PlaceholderImage from "../../assets/img/placeholder.png";

const StaffInvitation = () => {
  const {
    invitation,
    isLoadingInvitation,
    isErrorInvitation,
    errorInvitation,
    isLoadingAccepting,
    isLoadingDecline,
    show,
    close,
    accept,
    decline,
  } = useStaffInvitation();

  const { isLoadingFileUrl, isErrorFileUrl, errorFileUrl, fileUrl } =
    useFirebaseFile(invitation?.companyLogo);

  if (isLoadingInvitation) return <Loading />;

  if (isErrorInvitation) {
    toast.error("Couldn't load your invitations", {
      description: errorInvitation?.message,
    });
  }

  if (isErrorFileUrl)
    toast.error("Couldn't load clinic logo", {
      description: errorFileUrl?.message,
    });

  return (
    <>
      {invitation && (
        <Modal size="sm" show={show} onHide={close}>
          <Modal.Header onHide={close} />

          <Modal.Body className="space-y-4">
            {isLoadingFileUrl && (
              <div className="skeleton mx-auto size-28 rounded-lg" />
            )}

            {!isLoadingFileUrl && (
              <img
                className="mx-auto size-28 rounded-lg object-cover"
                src={fileUrl || PlaceholderImage}
                alt={invitation.name}
              />
            )}

            <div className="space-y-1">
              <p className="text-dark text-center text-xl font-medium">{`Join ${invitation.name}`}</p>

              {invitation.teamDescription && (
                <p className="text-center text-sm text-slate-500">
                  {invitation.teamDescription}
                </p>
              )}
            </div>

            <p className="!mt-10 rounded-lg bg-orange-50 p-3 text-sm font-medium text-orange-700">
              {`Your health journey starts here. Join ${invitation.name} to connect with their team and access personalised care and support through helfy®.`}
            </p>
          </Modal.Body>

          <Modal.Footer className="flex justify-end gap-3">
            <Button
              type="button"
              variant="secondary"
              loading={isLoadingDecline}
              disabled={isLoadingAccepting || isLoadingDecline}
              onClick={() => decline()}
            >
              Decline
            </Button>

            <Button
              type="button"
              variant="primary"
              className="px-8"
              loading={isLoadingAccepting}
              disabled={isLoadingAccepting || isLoadingDecline}
              onClick={() => accept()}
            >
              Join
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default StaffInvitation;
